// modifer: styles/jss/nextjs-material-kit-pro/pages/blogPostSections/sectionTextStyle
import { section, container, boxShadow } from 'styles/jss/original/base';

import imagesStyles from 'styles/jss/nextjs-material-kit-pro/imagesStyles.js';

const styles = {
  section: {
    ...section,
    padding: '0 0 40px',
    '@media (max-width: 992px)': {
      padding: '0 0 30px'
    },
    '@media (max-width: 640px)': {
      padding: '0 0 20px'
    }
  },
  container,
  ...imagesStyles,
  article: {
    '& h3, & h4': {
      marginTop: '25px',
      marginBottom: '25px',
      fontSize: '1.25rem',
      lineHeight: '1.5em',
      fontWeight: '700',
      '@media (max-width: 640px)': {
        marginTop: '20px',
        marginBottom: '20px',
        fontSize: '1rem'
      }
    },
    '& p': {
      fontSize: '0.9375rem'
    },
    '& img': {
      ...boxShadow,
      border: '0',
      borderRadius: '3px',
      maxWidth: '100%',
      height: 'auto',
      marginTop: '30px',
      marginBottom: '30px',
      '@media (max-width: 640px)': {
        marginTop: '20px',
        marginBottom: '20px'
      }
    },
    '& blockquote': {
      margin: '-30px 0 30px',
      '@media (max-width: 640px)': {
        margin: '-20px 0 20px'
      },
      '& p': {
        fontSize: '0.875rem'
      }
    }
  }
};

export default styles;
